/* eslint-disable no-template-curly-in-string */
import { object, string } from 'yup';

export const sectionValidationSchema = object().shape({
    sectionName: string()
        .min(2, ('Too Short!'))
        .max(50, 'Too Long!')
        .required('Required')
});
